import { defineMessages } from "react-intl";

import {
	combinedTransplantMessages,
	hyperImmunisedMessages,
	statusMessages,
	subjectMessages,
	urgencyMessages,
	validator
} from "lib/build/forms/htx/patientCondition";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientCondition: {
		id: "form.patient_condition",
		defaultMessage: "Státusz jelentés"
	},
	subject: {
		id: "form.patient_condition.subject",
		defaultMessage: "Tárgy"
	},
	description: {
		id: "form.patient_condition.description",
		defaultMessage: "Állapotváltozás leírása"
	},
	status: {
		id: "form.patient_condition.status",
		defaultMessage: "Páciens státusza"
	},
	urgency: {
		id: "form.patient_condition.urgency",
		defaultMessage: "Kezelőorvos által sürgetve"
	},
	waitingForExamination: {
		id: "form.patient_condition.waiting_for_examination",
		defaultMessage: "További vizsgálat szükséges"
	},
	combinedTransplant: {
		id: "form.patient_condition.combined_transplant",
		defaultMessage: "Kombinált transzplant"
	},
	hyperImmunised: {
		id: "form.patient_condition.hyper_immunised",
		defaultMessage: "Hyperimmunizált"
	}
});

const fields: { [key: string]: FieldData } = {
	subject: {
		type: "field",
		path: ["subject"],
		label: messages.subject,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: subjectMessages } }
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	status: {
		type: "field",
		path: ["status"],
		label: messages.status,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: statusMessages } }
	},
	urgency: {
		type: "field",
		path: ["urgency"],
		label: messages.urgency,
		errorMessages: genericErrorMessages,
		input: { type: "slider", props: { labels: urgencyMessages } }
	},
	combinedTransplant: {
		type: "field",
		path: ["combinedTransplant"],
		label: messages.combinedTransplant,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: combinedTransplantMessages }
		}
	},
	hyperImmunised: {
		type: "field",
		path: ["hyperImmunised"],
		label: messages.hyperImmunised,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: hyperImmunisedMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.subject },
				{ width: 6, field: fields.status }
			]
		},
		{ columns: [{ width: 12, field: fields.description }] },
		{ columns: [{ width: 12, field: fields.urgency }] },
		{ columns: [{ width: 12, field: fields.combinedTransplant }] },
		{ columns: [{ width: 12, field: fields.hyperImmunised }] }
	]
};

export const node: LeafNode = {
	id: "patientCondition",
	value: {
		title: messages.patientCondition,
		validator,
		fieldset,
		isLimitedAccess: true,
		applyCurrentDate: true,
		showTimeInput: true,
		returnTo: "status-history",
		defaults: [
			{
				path: ["status"],
				query: {
					interpretation: { vocab: "htx", code: "patient_status" }
				}
			},
			{
				path: ["urgency"],
				query: { interpretation: { vocab: "htx", code: "urgency" } }
			},
			{
				path: ["combinedTransplant"],
				query: {
					interpretation: {
						vocab: "htx",
						code: "combined_transplant"
					}
				}
			},
			{
				path: ["hyperImmunised"],
				query: {
					interpretation: { vocab: "htx", code: "hyper_immunised" }
				}
			}
		]
	}
};
